import { capitalize } from "@Utils/functions";

import styles from "./LineSwitch.module.scss";

interface StatusSwitcherProps<T> {
  options: { label: T; value: number }[];
  selectedOption: T;
  handleChange: (option: T) => void;
}

const StatusSwitcher = <T,>({
  options,
  selectedOption,
  handleChange,
}: StatusSwitcherProps<T>) => {
  return (
    <div className={styles.statusSwitcher}>
      {options
        .filter((option) => option.value)
        .map((option, index) => (
          <div
            key={index}
            className={`${styles.statusOption} ${
              selectedOption === option.label ? styles.selected : ""
            }`}
            onClick={() => handleChange(option.label)}
          >
            {`${capitalize(option.label as string)} ${option.value}`}
          </div>
        ))}
    </div>
  );
};

export default StatusSwitcher;
